import React from 'react';
import { Calendar, MapPin, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const AsiaBookRecords = () => {
  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh', padding: '80px 0' }}>
      <div className="container-custom">
        <Link to="/records" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '30px', fontWeight: '600' }}>
          <ArrowLeft size={20} />
          <span>Back to Records</span>
        </Link>
        <h1 className="heading-1" style={{ marginBottom: '50px', textAlign: 'center' }}>ASIA BOOK OF RECORDS</h1>
        
        <div style={{ maxWidth: '1000px', margin: '0 auto', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)', borderRadius: '16px', padding: '50px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{ display: 'inline-block', backgroundColor: '#e74c3c', color: 'white', padding: '8px 20px', borderRadius: '25px', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '20px' }}>
              ASIA BOOK OF RECORDS
            </div>
            <h2 className="heading-2" style={{ color: 'var(--brand-primary)', fontSize: '1.8rem', marginBottom: '10px' }}>Maximum authors contributing to a book on covid-19 and its impact</h2>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
            <div style={{ maxWidth: '600px', width: '100%' }}>
              <img src="/records/asia-book/asia1.png" alt="Asia Record 1" style={{ width: '100%', height: '400px', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', border: '2px solid var(--border-medium)' }} />
            </div>
          </div>
          
          <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', marginBottom: '40px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
              <Calendar size={22} color="var(--brand-primary)" />
              <span style={{ fontWeight: '600', fontSize: '1rem' }}>05 JUNE 2021</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--bg-page)', padding: '12px 20px', borderRadius: '25px' }}>
              <MapPin size={22} color="var(--brand-primary)" />
              <span style={{ fontWeight: '600', fontSize: '1rem' }}>Chennai</span>
            </div>
          </div>
          
          <div style={{ backgroundColor: 'var(--bg-page)', padding: '30px', borderRadius: '12px', border: '1px solid var(--border-medium)' }}>
            <p className="body-medium" style={{ lineHeight: '1.8', textAlign: 'justify', fontSize: '1.1rem', margin: 0 }}>
              The record for the maximum number of authors contributing to a book on COVID-19 and its impact was set by ESN Publications, India, under the guidance of J. Banuchandar, Founder and Chairman. A total of 1,498 authors across the world contributed articles to the book titled 'COVID-19 AND ITS IMPACT' (ISBN: 978-81-947019-4-1), which aims to establish the impact of COVID-19 on various Multidisciplinary Researches like Medical, Engineering, Arts, Science, Society Environment, Literature.
            </p>
            <div style={{ marginTop: '24px', textAlign: 'center' }}>
              <a
                href="https://www.asiabookofrecords.com/maximum-authors-contributing-to-a-book-on-covid-19-and-its-impact/"
                target="_blank"
                rel="noreferrer noopener"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  backgroundColor: '#ffb703',
                  color: '#102a43',
                  fontWeight: '700',
                  textDecoration: 'none',
                  boxShadow: '0 12px 30px rgba(255, 181, 3, 0.2)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                onMouseEnter={(event) => { event.currentTarget.style.transform = 'translateY(-2px)'; event.currentTarget.style.boxShadow = '0 18px 40px rgba(255, 181, 3, 0.28)'; }}
                onMouseLeave={(event) => { event.currentTarget.style.transform = 'translateY(0)'; event.currentTarget.style.boxShadow = '0 12px 30px rgba(255, 181, 3, 0.2)'; }}
              >
                View Official Record
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AsiaBookRecords;